import React, { useRef } from 'react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import {
  FilterKey,
  FilterValue,
  ActiveFilters,
} from '~/cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterTypes';
import { useCollapsingButtons } from '~/cards/hooks/useCollapsingButtons';
import { FilterButtons } from './FilterButtons/FilterButtons';

import { FilterChip, FilterRow } from './FilterStyles.styles';

const MoreFiltersButton = ({
  isCompact,
  setIsCompact,
}: {
  isCompact: boolean;
  setIsCompact: (isCompact: boolean) => void;
}) => {
  return (
    <div>
      {isCompact ? (
        <FilterChip
          data-type="more-filters"
          onClick={() => {
            setIsCompact(false);
          }}
        >
          More
        </FilterChip>
      ) : (
        <LinkV2
          role="button"
          type="button"
          variant="primary"
          onClick={() => {
            setIsCompact(true);
          }}
        >
          Less filters
        </LinkV2>
      )}
    </div>
  );
};

type PlpRedesignFilterMenuProps = {
  filterMenuList: any[];
  searchFilters: ActiveFilters;
  onUpdateSearchFilters: (key: FilterKey, value: FilterValue) => void;
};

const PlpRedesignFilterMenu = (props: PlpRedesignFilterMenuProps): JSX.Element => {
  const { filterMenuList, searchFilters, onUpdateSearchFilters } = props;

  const ref = useRef<HTMLDivElement>(null);
  const [isCompact, setIsCompact] = useCollapsingButtons(ref);

  return (
    <FilterRow isCompact={isCompact} ref={ref} data-testid="plp-filters-wrapper">
      {filterMenuList.map((filterInfo) => (
        <FilterButtons
          key={filterInfo.label}
          filterInfo={filterInfo}
          updateFilter={onUpdateSearchFilters}
          activeFilters={searchFilters}
        />
      ))}
      <MoreFiltersButton isCompact={isCompact} setIsCompact={setIsCompact} />
    </FilterRow>
  );
};

export default PlpRedesignFilterMenu;
